/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import localeEnGb from '@angular/common/locales/en-GB';
import localeDe from '@angular/common/locales/de';
import localePt from '@angular/common/locales/pt-PT';
import localeEnGbExtra from '@angular/common/locales/extra/en-GB';
import localeDeExtra from '@angular/common/locales/extra/de';
import localePtExtra from '@angular/common/locales/extra/pt-PT';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeEnGb, 'en-GB', localeEnGbExtra);
registerLocaleData(localeDe, 'de-DE', localeDeExtra);
registerLocaleData(localePt, 'pt-PT', localePtExtra);

//Add Font Imports here...

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
